import { useCallback } from 'react';
import { useQuery, useQueryClient, UseQueryResult } from 'react-query';
import { TeamsAPI, TeamsBulkUpdateStatus } from 'api/teams';

export const PROJECT_PLACEHOLDER_UPDATE_STATUS =
  'project_placeholder_update_status';

export const useProjectPlaceholderUpdateStatus = (
  projectId: number,
): UseQueryResult<TeamsBulkUpdateStatus[]> => {
  return useQuery<TeamsBulkUpdateStatus[]>(
    PROJECT_PLACEHOLDER_UPDATE_STATUS,
    async () => {
      return TeamsAPI.getTeamsBulkUpdateProgress(projectId);
    },
    {
      refetchOnMount: true,
    },
  );
};

export const useSetProjectPlaceholderUpdateStatus = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (status: TeamsBulkUpdateStatus[]) => {
      queryClient.setQueryData(PROJECT_PLACEHOLDER_UPDATE_STATUS, status);
      queryClient.invalidateQueries(PROJECT_PLACEHOLDER_UPDATE_STATUS, {
        exact: true,
        refetchActive: false,
      });
    },
    [queryClient],
  );
};

export const useProjectPlaceholderUpdateStatusRefresh = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries(PROJECT_PLACEHOLDER_UPDATE_STATUS);
  };
};
